import React from 'react'
import styled from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'

type Variant = 'success' | 'error' | 'warning'

interface Props {
  variant: Variant

  customColor?: string
  className?: string
}

export const FormFeedback: React.FC<Props> = ({
  children,
  className,
  variant,
  customColor,
}) => {
  return (
    <Wrapper className={className} customColor={customColor} variant={variant}>
      {children}
    </Wrapper>
  )
}

interface WrapperProps {
  customColor?: string
  variant: Variant
}

const Wrapper = styled.div<WrapperProps>`
  font-size: 0.9rem;
  margin-top: 0.5rem;

  color: ${({ variant, customColor }) =>
    customColor ||
    (variant === 'success'
      ? themeEstra.color.primari.verde
      : variant === 'error'
      ? themeEstra.color.primari.arancione
      : 'yellow')};
`
